import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router";
import AuthContext from "../global/auth-context";
import { FaUserCircle } from "react-icons/fa";
import { IoMdMenu } from "react-icons/io";
import Menu from "./Menu";
import { IoClose } from "react-icons/io5";
import { hover } from "@testing-library/user-event/dist/hover";
import { RiUserStarFill } from "react-icons/ri";
import { RiUserFill } from "react-icons/ri";

const HeaderNav = ({ page }) => {
  let { isAuth, logout, userData, menuOpen, setMenuOpen } =
    useContext(AuthContext);
  let navigate = useNavigate();

  return (
    <>
      <div className="h-14 bg-myDarkGreen flex px-5 items-center pointer-events-auto justify-between">
        <a href={"/"} className="flex items-center gap-2">
          <img src="/logo.png" className="h-12" />
        </a>
        <div className="flex gap-10 laptop">
          <a
            href={"/"}
            className={`font-bold text-lg ${
              page == "home" ? "text-yellow-500" : "text-white"
            }  hover:text-yellow-500`}
          >
            Home
          </a>
          <a
            href={"/convert"}
            className={`${
              page == "convert" ? "text-yellow-500" : "text-white"
            } font-bold text-lg hover:text-yellow-500`}
          >
            Convert
          </a>
          <a
            href={"/buy-units"}
            className={`${
              page == "units" ? "text-yellow-500" : "text-white"
            } font-bold text-lg hover:text-yellow-500 ${page}`}
          >
            Buy Units
          </a>
          <a
            href={"/premium"}
            className={`${
              page == "premium" ? "text-yellow-500" : "text-white"
            } font-bold text-lg hover:text-yellow-500 ${
              isAuth && userData.role == "paid" && "hidden"
            }`}
          >
            Get Premium
          </a>
          <a
            href={"/download-app"}
            className={`${
              page == "downloadApp" ? "text-yellow-500" : "text-white"
            } font-bold text-lg hover:text-yellow-500`}
          >
            Download App
          </a>
        </div>
        <div className="gap-2 flex h-10 justify-center items-center laptop">
          {isAuth ? (
            <>
              <Link to="/profile" className="flex px-3">
                {userData.role == "paid" ? (
                  <div
                    className={`${
                      page == "profile" ? "bg-yellow-500" : "bg-white"
                    } p-2 rounded-full flex items-center justify-center hover:bg-yellow-500`}
                  >
                    <RiUserStarFill size={25} color={"#034203"} />
                  </div>
                ) : (
                  <div
                    className={`${
                      page == "profile" ? "bg-yellow-500" : "bg-white"
                    } p-2 rounded-full flex items-center justify-center hover:bg-yellow-500`}
                  >
                    <RiUserFill size={25} color={"#034203"} />
                  </div>
                )}
              </Link>
              <Link
                onClick={() => {
                  logout();
                  return navigate("/");
                }}
                className="h-8 bg-red-400 py-1 px-3 rounded-md text-black font-bold  hover:bg-yellow-500"
              >
                Logout
              </Link>
            </>
          ) : (
            <>
              <Link
                to={"/login"}
                className="h-8 hover:bg-yellow-500 bg-myLightGreen py-1 px-3 rounded-md text-black font-bold"
              >
                Login
              </Link>
              <Link
                to={"/register"}
                className="h-8  hover:bg-yellow-500 bg-myLightGreen py-1 px-2 rounded-md text-black font-bold"
              >
                SignUp
              </Link>
            </>
          )}
        </div>
        {menuOpen == false && (
          <Link
            onClick={() => {
              setMenuOpen(true);
            }}
            to={"/menu"}
            className="phone"
          >
            <IoMdMenu size={30} color="white" />
          </Link>
        )}
        {menuOpen && (
          <Link
            onClick={() => {
              setMenuOpen(false);
              navigate(-1);
            }}
            className="phone"
          >
            <IoClose size={30} color="white" />
          </Link>
        )}
      </div>
      {/* {menuOpen && navigate("/menu")} */}
    </>
  );
};

export default HeaderNav;
